import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d9e5b9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4 px-lg-5 px-3" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  class: "border-1 my-3 px-3",
  style: {"border":"1px solid grey"}
}
const _hoisted_4 = { class: "mt-3 box_container" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "px-lg-3 px-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center no_need py-5" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "No Pending Priority Health Need Found!")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "data_container overflow-auto"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-5" }, null, -1))
const _hoisted_13 = { class: "px-lg-3 px-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center no_need py-5" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "No Published Health Need Found")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "data_container overflow-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_CardList = _resolveComponent("CardList")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_ScrollArea = _resolveComponent("ScrollArea")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerData, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "bx text-center",
            key: i
          }, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(item.value), 1),
            _createElementVNode("p", null, _toDisplayString(item.title), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_Accordion, null, {
        default: _withCtx(() => [
          (_ctx.user === 'Program_Coordinator')
            ? (_openBlock(), _createBlock(_component_AccordionTab, {
                key: 0,
                header: "Pending Evaluation"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_6, [
                    (_ctx.datas.length === 0 && _ctx.loading === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                            return _createVNode(_component_Skeleton, {
                              width: "100%",
                              height: "6rem",
                              class: "mb-3",
                              key: i
                            })
                          }), 64))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.datas.length === 0 && _ctx.loading === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (_ctx.datas.length > 0)
                      ? (_openBlock(), _createElementBlock("main", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datas, (item, i) => {
                            return (_openBlock(), _createBlock(_component_CardList, {
                              key: i,
                              body: item,
                              card: _ctx.cardListStyle,
                              route: `/submit-proposal/call-for-proposal/${item.id}/?id=${item.id}`
                            }, null, 8, ["body", "card", "route"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_12,
          _createVNode(_component_AccordionTab, { header: "Published Health Needs" }, {
            default: _withCtx(() => [
              _createVNode(_component_ScrollArea, { onProgramId: _ctx.programArea }, null, 8, ["onProgramId"]),
              _createElementVNode("section", _hoisted_13, [
                (_ctx.needLoading === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                        return _createVNode(_component_Skeleton, {
                          width: "100%",
                          height: "6rem",
                          class: "mb-3",
                          key: i
                        })
                      }), 64))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_ctx.publishedData.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_ctx.publishedData.length > 0)
                        ? (_openBlock(), _createElementBlock("main", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishedData, (item, i) => {
                              return (_openBlock(), _createBlock(_component_CardList, {
                                key: i,
                                body: item,
                                card: _ctx.cardListStyle,
                                route: `/submit-proposal/call-for-proposal/${item.id}/?id=${item.id}`
                              }, null, 8, ["body", "card", "route"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])),
                (_ctx.publishedData.length > 0)
                  ? (_openBlock(), _createBlock(_component_Paginator, {
                      key: 2,
                      rows: _ctx.publishedDataPagination.size,
                      totalRecords: _ctx.publishedDataPagination.total_records,
                      onPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPage($event)))
                    }, null, 8, ["rows", "totalRecords"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}